import {TableLayout} from "../../../../../../layouts/tableLayout";
import ProductTHead from "./~productTHead";
import ProductTBody from "./~productTBody";
import ActionFormBrnList from "../../actionFormBrnList";

export const CategoryType = () => {

   return (
      <>
         <TableLayout
            table={{
               tHead: <ProductTHead/>,
               tBody: <ProductTBody/>,
            }}
         />
      </>
   )
}